export default __webpack_public_path__ + "static/media/full_TheCleansingFlame.a89ef636.jpg";